import Backbone from 'backbone'
import _ from 'lodash'

/**
 * Keeps track of data that was sent as part of the globals response.  The data
 * must have an ID property.  For example, used by databases.js and licenses.js
 */
function GlobalsDataById(key, singularKey) {
	// key is the name of the data in globals, e.g. 'databases' or 'licenses'
	this.key = key
	// singular key name for backbone events, e.g. 'database' for 'delete:database'
	this.singularKey = singularKey || key
	this._all = []

	Backbone.on('load', function(data) {
		if (data[key]) {
			this.update(data[key])
		}
	}.bind(this))

	Backbone.on('add:' + this.singularKey, function(datum) {
		datum = _.cloneDeep(datum)
		this._all.push(datum.attributes || datum)
		if (this.byId) {
			this.byId[datum.id] = datum
		}
	}.bind(this))

	Backbone.on('edit:' + this.singularKey, function(datum) {
		datum = _.cloneDeep(datum)
		_.each(this._all, (item, i) => {
			if (item.id == datum.id) {
				this._all[i] = datum.attributes || datum
			}
		})
		if (this.byId) {
			this.byId[datum.id] = datum
		}
	}.bind(this))

	Backbone.on('delete:' + this.singularKey, function(datum) {
		_.remove(this._all, function(item) {
			return item.id == datum.id
		})
		if (this.byId) {
			this.byId[datum.id] = undefined
		}
	}.bind(this))
}

_.extend(GlobalsDataById.prototype, {

	/**
	 * Returns the item with the given ID if one if specified, or all
	 * items if no ID is specified.
	 */
	get: function(id) {
		if (_.isUndefined(id)) {
			return _.cloneDeep(this._all)
		}

		if (!this.byId) {
			this.byId = _.keyBy(this._all, 'id')
		}
		return this.byId[id]
	},

	update: function(data) {
		// keep our own copy to prevent surprises
		this._all = _.cloneDeep(data)
		delete this.byId
	}

})

export default GlobalsDataById

GlobalsDataById.__filename__ = 'components/globals-data-by-id.js'
